<template>
  <ts-dropdown
    :placeholder="placeholderOrValue"
    :size="size"
    :width="width"
    :popover-width="260"
    :open="open"
    :disabled="disabled"
    @click="handleDropdownClick"
    @close="handleSaveClick"
  >
  <template #icon>
    <slot name="icon"></slot>
  </template>
    <div v-if="origin" class="origin">
      <span>
        <a class="origin-link" @click="handleOriginClick">&lt;&lt;</a>
      </span>
      <span>
        <a class="origin-link" @click="handleNowClick">&gt;&gt;</a>
      </span>
    </div>
    <ts-date-picker ref="datePicker" :mode="mode" v-model="dates"></ts-date-picker>
    <template #footer>
      <div class="actions">
        <span>
          <ts-link @click="handleResetClick">Reset</ts-link>
        </span>
        <ts-link type="primary" @click="handleSaveClick">Save</ts-link>
      </div>
    </template>
  </ts-dropdown>
</template>

<style lang="scss" scoped>
.origin {
  font-family: Roboto;
  font-size: 12px;
  color: #6d7587;
  display: flex;
  justify-content: space-between;
  margin: 12px;

  .origin-link {
    cursor: pointer;
  }
}

.actions {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 12px;
}
</style>

<script>
import { format } from 'date-fns';

export default {
  props: {
    mode: {
      type: String,
      default: 'range'
    },
    placeholder: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 300
    },
    size: {
      type: String,
      default: 'small'
    },
    value: {
      type: [Object, Date],
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    origin: {
      type: Date,
      default: null
    }
  },
  data() {
    return {
      dates: null,
      open: false
    };
  },
  computed: {
    placeholderOrValue() {
      if (this.value && this.value.start && this.value.end) {
        return format(this.value.start, 'yyyy-MM-dd') + ' - ' + format(this.value.end, 'yyyy-MM-dd');
      }
      if (this.value) {
        return format(this.value, 'yyyy-MM-dd');
      }
      return this.placeholder;
    }
  },
  methods: {
    handleDropdownClick() {
      this.open = !this.open;
      if (this.open) {
        this.dates = this.value;
      }
    },
    handleOriginClick() {
      this.$refs.datePicker.$refs.calendar.$refs.calendar.move(this.origin);
    },
    handleNowClick() {
      this.$refs.datePicker.$refs.calendar.$refs.calendar.move(new Date());
    },
    handleResetClick() {
      this.open = false;
      this.$emit('input', null);
    },
    handleSaveClick() {
      this.open = false;
      this.$emit('input', this.dates);
    }
  }
};
</script>
